import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const wetBulb_IN: typeof valueTypeRenderers.wetBulb_IN = {
  label: () => unitConverter.wetBulbInCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.wetBulbInCanopy().title(),
      render: (n) => unitConverter.wetBulbInCanopy(n).valueAsString(),
    }),
}
